import { Reveal } from './Reveal';
import { CHAPTERS, SECTORS } from '@/data';
import { INVESTOR } from '@/constants/testIds';

export const Thesis = () => (
  <section
    id="thesis"
    data-testid={INVESTOR.thesis}
    className="bg-[#0c0e12] border-y border-border"
  >
    <div className="mx-auto max-w-screen-2xl px-6 md:px-12 py-32 md:py-40">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-24">
        <Reveal>
          <span className="overline">02 — La thèse</span>
          <h2 className="mt-6 font-display font-light tracking-tight text-5xl sm:text-6xl lg:text-7xl text-foreground">
            Quatre principes
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="max-w-xs font-body font-light leading-relaxed text-muted-foreground">
            Une doctrine d'investissement claire, appliquée avec discipline à
            chaque décision.
          </p>
        </Reveal>
      </div>

      <div className="divide-y divide-border border-t border-border">
        {CHAPTERS.map((c) => (
          <Reveal key={c.n}>
            <div
              data-testid={INVESTOR.thesisChapter(c.n)}
              className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 py-14 transition-colors duration-500"
            >
              <div className="md:col-span-2 font-mono text-primary text-sm tracking-widest">
                {c.n}
              </div>
              <h3 className="md:col-span-5 font-display font-light text-3xl md:text-4xl tracking-tight text-foreground group-hover:text-primary transition-colors duration-500">
                {c.title}
              </h3>
              <p className="md:col-span-5 font-body font-light leading-relaxed text-muted-foreground">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      {/* Sectors */}
      <div className="mt-24">
        <Reveal>
          <span className="overline">Secteurs de prédilection</span>
        </Reveal>
        <div className="mt-8 flex flex-wrap gap-x-8 gap-y-4">
          {SECTORS.map((s, i) => (
            <Reveal key={s} delay={i * 0.05}>
              <span className="font-display italic text-2xl md:text-3xl text-foreground/80 hover:text-primary transition-colors duration-300">
                {s}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
